import React from 'react';
import { Alert } from 'reactstrap';
import Company from './Company';
import SortIcons from './ProposalsSortIcons';
const CompaniesList = ({
  companies = [],
  disabledCompany,
  onDelete,
  onEdit,
  onSetStatus,
  user,
  deleteMode,
  onRecover,
  onSort,
  sortValue,
}) => {
  return (
    <div className="table-header-fixed">
      <table>
        <thead>
          <tr>
            <th className="cursor-pointer" onClick={() => onSort('epikCustomerId')}>
              Customer ID <SortIcons sortObj={sortValue} sortName="epikCustomerId" />
            </th>
            <th className="cursor-pointer">Group</th>
            <th className="cursor-pointer" onClick={() => onSort('name')}>
              Name <SortIcons sortObj={sortValue} sortName="name" />
            </th>

            <th className="cursor-pointer" onClick={() => onSort('managedDevices')}>
              Managed Devices <SortIcons sortObj={sortValue} sortName="managedDevices" />
            </th>

            <th className="cursor-pointer" onClick={() => onSort('monitoredDevices')}>
              Monitored Devices <SortIcons sortObj={sortValue} sortName="monitoredDevices" />
            </th>
            <th className="cursor-pointer" onClick={() => onSort('companyType')}>
              Type <SortIcons sortObj={sortValue} sortName="companyType" />
            </th>
            <th>Status</th>
            <th className="cursor-pointer" onClick={() => onSort('creationDate')}>
              Created On <SortIcons sortObj={sortValue} sortName="creationDate" />
            </th>
            <th colSpan="1">Actions</th>
          </tr>
        </thead>
        <tbody>
          {companies && companies.length ? (
            companies.map(company => (
              <Company
                onRecover={onRecover}
                deleteMode={deleteMode}
                key={company._id}
                company={company}
                onDelete={onDelete}
                onSetStatus={onSetStatus}
                onEdit={onEdit}
                user={user}
              // disabled={company._id === disabledCompany}
              />
            ))
          ) : (
            <tr>
              <td colSpan={6}>
                <Alert rowSpan={6} color="info">
                  No Companies Found
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CompaniesList;
